import React, { Component } from 'react';
import Radium from 'radium';
import TaskCircle from './TaskCircle';

const COLORS = [
	{color1: "#fa12bc", color2: "#ea1efa"},
	{color1: "#43cea2", color2: "#185a9d"},
	{color1: "#ee0979", color2: "#ff6a00"},
	{color1: "#4568dc", color2: "#b06ab3"},
	{color1: "#FFBAB1", color2: "#FFFAAE"},
	{color1: "#AEFFD6", color2: "#B1EAFF"}
];

class BubbleColorChooser extends Component {
	
	isSelected(color) {
		if (!this.props.selectedColor) {
			return false;
		}

		if (this.props.selectedColor.color1 === color.color1 && this.props.selectedColor.color2 === color.color2) {
			return true;
		}

		return false;
	} 
	
	render() {
		return (
			<div style={this.localStyles().container}>
				<div style={this.props.style.global.label}>Color</div>
			
				<div style={this.localStyles().options}>
					{COLORS.map((color) => {
						const key = `${color.color1}${color.color2}`;
						return (
							<div key={key} style={this.localStyles().option}>
								<TaskCircle
									key={key}
									onTick={() => this.props.onSelectColor(color)}
									style={this.props.style}
									completed={this.isSelected(color)}
									selectedBubble={{id: key, color_1: color.color1, color_2: color.color2}}
								/>	
							</div>
							
						
						)
					})}
				</div>
			
			</div>
		);
	}

	localStyles() {
		return {
			container: {
				marginTop: 30
			},
			option: {
				cursor: "pointer"
			},
			options: {
				display: "flex",
				flexDirection: "row",
				flexWrap: "wrap",
				marginTop: 30
			}
		}
	}
}

export default Radium(BubbleColorChooser);


// WEBPACK FOOTER //
// ./src/components/BubbleColorChooser.js